import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { ContactForm } from './components/ContactForm';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <HowItWorksSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <ContactForm data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
      <WhatsAppButton data-id="element-10" />
    </div>;
}